export const PhotoActionTypes = {
    LOAD_PHOTOS_START: 'LOAD_PHOTOS_START',
    LOAD_PHOTOS_SUCCESS: 'LOAD_PHOTOS_SUCCESS',
}
